import each from "lodash-es/each";
import get from "lodash-es/get";
import isEmpty from "lodash-es/isEmpty";
import map from "lodash-es/map";
import merge from "lodash-es/merge";

class UserForm {
  constructor(elem) {
    this.$block = $(elem);
    this.actionInfo = this.$block.data('action-info');
    this.actionAgreement = this.$block.data('action-agreement');
    this.sessid = window.BX ? window.BX.bitrix_sessid() : '';
    this.$agreementsContainer = this.$block.find('.user-form__agreements');
    this.$name = this.$block.find('[name="user-form-name"]');
    this.$email = this.$block.find('[name="user-form-email"]');
    this.$tel = this.$block.find('[name="user-form-tel"]');
    this.info().then((response) => {
      if (!get(response, 'result.isAuthorized')) {
        this.agreement();
      }
    })
  }

  apply = (json) => new Promise((resolve) => window.getBH((bh) => resolve(bh.apply(json))));

  fetch = ({ url, options }) => {
    return $.ajax(url + `?sessid=${this.sessid}`, {
      ...options,
      data: JSON.stringify(options['data']),
    }).always((response) => {
      const sessid = get(response, 'responseJSON.result.sessid', '');
      if (sessid && sessid !== this.sessid) this.sessid = sessid;
    });
  }
  info = () => new Promise((resolve) => {
    this.fetch({ url: this.actionInfo, options: {
        method: process.env.NODE_ENV === 'development' ? 'GET' : 'POST',
        dataType: 'json',
      } }).done((response) => {
      const user = get(response, 'result.user', {});
      if (!isEmpty(user)) {
       !isEmpty(this.$name) && this.$name.val(get(user, 'NAME', ''));
       !isEmpty(this.$email) && this.$email.val(get(user, 'EMAIL', ''));
       !isEmpty(this.$tel) && this.$tel.val(get(user, 'PHONE', ''));
      }
      resolve(response);
    })
  })

  agreement = () => new Promise((resolve) => {
    this.fetch({ url: this.actionAgreement, options: {
        method: process.env.NODE_ENV === 'development' ? 'GET' : 'POST',
        dataType: 'json',
      } }).done(async (response) => {
      const agreements = get(response, 'result.agreements', []);
      if (!isEmpty(agreements) && !isEmpty(this.$agreementsContainer)) {
        this.$agreementsContainer.html(await this.apply(map(agreements, (item) => [
          {block: 'form-check mb-2', content: [
              {tag: 'input', cls: 'form-check__input form-check-input',
                attrs: {
                  type: 'checkbox',
                  'data-empty': `Необходимо принять: ${get(item, 'name')}`,
                  required: true,
                  name: 'agreement-checkbox' + get(item, 'id', ''),
                  checked: get(item, 'isMarked', false),
                  'data-agreement-checkbox': get(item, 'id', false),
                  value: get(item, 'id', ''),
                  id: 'agreement-checkbox' + get(item, 'id', ''),
                },
              },
              {tag: 'label', attrs: {
                  for: 'agreement-checkbox' + get(item, 'id', ''),
                }, cls: 'form-check__label form-check-label', content: get(item, 'labelText', '')}
            ]},
        ])))
      }
      resolve(agreements);
    })
  })

  static init() {
    const $userForm = $('.user-form:not(.init)');
    each($userForm, (elem) => {
      return new UserForm(elem);
    });
  }
}


$(document).ready(() => UserForm.init());

window.Block = window.Block ? window.Block : {};
window.Block.UserForm = UserForm;
